var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IncentivesRole_1;
import { JSON, JsonConverter, JsonSchemaV2, MapConverter } from '@symon-ai/wisepipe-serialize';
import { incentivesRoleSchema } from './jsonSchemas/incentivesRole';
import { incentivesRoleSchemaValidation } from '../validations.generated';
let IncentivesRole = IncentivesRole_1 = class IncentivesRole {
    constructor(orgID, roleID, users, permissions) {
        this.orgID = orgID;
        this.roleID = roleID;
        this.users = users;
        this.permissions = permissions;
        JSON.validate(this, IncentivesRole_1);
    }
};
__decorate([
    JsonConverter(new MapConverter())
], IncentivesRole.prototype, "permissions", void 0);
IncentivesRole = IncentivesRole_1 = __decorate([
    JsonSchemaV2(incentivesRoleSchema, incentivesRoleSchemaValidation)
], IncentivesRole);
export { IncentivesRole };
//# sourceMappingURL=incentivesRole.js.map